import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useLocation } from 'react-router-dom';
import AppTabs from '../../components/AppTabs/AppTabs';
import './SimArtAdmin.scss';
import ArtRequestsAdmin from '../../components/SimArtRequestsAdmin/ArtRequestsAdmin';
import SimRequestsAdmin from '../../components/SimArtRequestsAdmin/SimRequestsAdmin';
export default function SimArtAdmin() {
  const { t } = useTranslation();
  const location = useLocation();
  const [tabValue, setTabValue] = useState(0);

  const getTabLabels = () => {
    const tabLabels = ['SIM', 'ART'];
    return tabLabels;
  };

  const getTabElements = () => {
    const tabElement1 = <SimRequestsAdmin />;
    const tabElement2 = location.state ? (
      <ArtRequestsAdmin position={(location.state as any).pos} />
    ) : (
      <ArtRequestsAdmin />
    );
    return [tabElement1, tabElement2];
  };

  const handleTabChange = (event: React.ChangeEvent<{}>, newValue: number) => {
    setTabValue(newValue);
  };

  return (
    <div className="simart-admin-ec-container">
      <div className="simart-admin-ec__header">
        <h1>{t('simArtAdmin.title')}</h1>
      </div>
      <AppTabs
        tabLabels={getTabLabels()}
        tabElements={getTabElements()}
        handleTabChange={handleTabChange}
        tabValue={tabValue}
      />
    </div>
  );
}
